import { createContext, useContext } from 'react';

export const UserAgentContext = createContext({});
export const useUserAgentContext = () => useContext(UserAgentContext);
